import {IBridge} from '@kta20-core/interfaces/i-bridge';
import * as Constants from '@kta20-core/constants';
import {IBridgeManager} from "@kta20-core/i-bridge-manager";


/**
 * Singleton object managing module's 
 * bridge instances, registration, caching
 * and forwarding to requesting modules.
 * Always invoke this manager when you need
 * inter-module communication. 
 */
class BridgeManager implements IBridgeManager {

    private static inst: BridgeManager;

    static get(): BridgeManager {
        if (!BridgeManager.inst)
            BridgeManager.inst = new BridgeManager();

        return BridgeManager.inst;
    }

    constructor() {
        if (BridgeManager.inst)
            throw new Error(Constants.SINGLETON_CLASS);
    }

    /**
     * List of all managed bridged.
     */
    private registry: RegistryItem[] = [];

    /**
     * Register a bridge into the manager
     * to make it available to other
     * modules to communicate to.
     * @param interfaceName : name of the interface implemented by the bridge (will be used to get the actual bridge instance from the client)
     * @param bridge : bridge instance
     */
    addBridge(interfaceName: string, bridge: IBridge) {
        if (!this.hasBridge(interfaceName))
            this.registry.push(new RegistryItem({
                interfaceName: interfaceName,
                bridge: bridge
            }));

        return this;
    }

    /**
     * Check if a bridge is registered within
     * the manager and then available to other
     * modules.
     * @param interfaceName : name of the interface implemented by the bridge
     */
    hasBridge(interfaceName: string): IBridge {
        return this.registry.find(item => item.interfaceName === interfaceName) != null;
    }

    /**
     * Get a bridge instance by its interface name.
     * @param interfaceName : name of the interface implemented by the bridge
     */
    getBridge(interfaceName: string): IBridge {
        const item: RegistryItem = this.registry.find(item => item.interfaceName === interfaceName);
        return item ? item.bridge : null;
    }

}

/**
 * Utility class to store 
 * bridge instances in the
 * manager registry
 */
class RegistryItem {
    interfaceName: string;
    bridge: IBridge;

    public constructor(init?: Partial<RegistryItem>) {
        Object.assign(this, init);
    }
}

export { IBridge, BridgeManager };